import React from "react";

/** Concentric lines like a passport page; purely decorative. */
export const CardGuilloche: React.FC<{ color: string }> = ({ color }) => (
  <svg
    className="pointer-events-none absolute inset-0 h-full w-full"
    viewBox="0 0 342 216"
    preserveAspectRatio="xMaxYMin slice"
    aria-hidden="true"
  >
    <g fill="none" stroke={color} strokeWidth="1">
      {[60, 96, 132, 168, 204, 240, 276, 312].map((rx) => (
        <ellipse key={rx} cx="318" cy="22" rx={rx} ry={rx * 0.76} />
      ))}
    </g>
  </svg>
);

/** The five-dot mark of the logo, drawn so it takes the card's colour. */
export const CardMark: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <circle cx="12" cy="4" r="3" />
    <circle cx="4" cy="12" r="3" />
    <circle cx="12" cy="12" r="3" />
    <circle cx="20" cy="12" r="3" />
    <circle cx="12" cy="20" r="3" />
  </svg>
);

export const CardChip: React.FC<{ background: string }> = ({ background }) => (
  <div
    className="relative h-[26px] w-[34px] rounded-md"
    style={{ background, boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.18)" }}
    aria-hidden="true"
  >
    <div className="absolute inset-y-0 left-[11px] w-px bg-black/20" />
    <div className="absolute inset-y-0 left-[22px] w-px bg-black/20" />
    <div className="absolute inset-x-0 top-[13px] h-px bg-black/20" />
  </div>
);
